import{memo as o}from"../../../utils/memo.mjs.js";const i=o((()=>void 0!==window.ScrollTimeline));export{i as supportsScrollTimeline};
